import LogoDevIcon from '@mui/icons-material/LogoDev';
import { Stack, Typography } from "@mui/material"

import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext } from "react";

export function DevButton({...params}){

    const { mode } = useContext(ThemeContext);

    let devButtonState = params.devButtonState
    let setDevButtonState = params.setDevButtonState
    let handleClick = params.handleClick

    let lightColors = ["#02203B", "#06569D", "#138BF6"  ]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"  ]

    let onButtonPage = false
    let url = window.location.pathname
    if (url === '/devpage') onButtonPage = true

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (onButtonPage) setDevButtonState('hover')
        else if (devButtonState !== 'active') setDevButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setDevButtonState('default')
        if (onButtonPage) setDevButtonState('active')
        else if (devButtonState !== 'active') setDevButtonState('default')
    }

    let devButtonColor = ''

    if (mode === 'light'){
        if (devButtonState === 'active') devButtonColor = lightColors[0]
        else if (devButtonState === 'default') devButtonColor = lightColors[1]
        else if (devButtonState === 'hover') devButtonColor = lightColors[2]
    } 
    else if (mode === 'dark'){
        if (devButtonState === 'active') devButtonColor = darkColors[0]
        else if (devButtonState === 'default') devButtonColor = darkColors[1]
        else if (devButtonState === 'hover') devButtonColor = darkColors[2]
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: devButtonColor}

    let labelText = ''
    if (window.location.pathname === "/devpage") labelText = 'Basic'
    else labelText = 'Dev'

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>
            <LogoDevIcon fontSize="large" sx={{color: devButtonColor}}/>
            <Typography sx={[labelFormatting, labelStyling]}>{labelText}</Typography>
        </Stack>
    )
}
